export const iconFontAwesomeUsersPeopleUserPlus = (
	<i className="fa-solid fa-user-plus"></i>
);
